import { Phone, MessageCircle } from "lucide-react";
import { CONTACT, WHATSAPP_BASE } from "@/data/site";

export const FloatingButtons = () => {
  return (
    <div
      className="fixed bottom-5 right-5 z-50 flex flex-col gap-3"
      data-testid="floating-actions"
    >
      <a
        href={`${WHATSAPP_BASE}?text=${encodeURIComponent(
          "Hello Dr. Sanjay Teza, I would like to book a surgical consultation.",
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_6px_20px_rgba(37,211,102,0.45)] transition-transform duration-200 hover:-translate-y-1"
      >
        <MessageCircle className="h-7 w-7" />
      </a>
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        data-testid="floating-call"
        aria-label="Call the clinic"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-primary text-white shadow-[0_6px_20px_rgba(0,71,171,0.4)] transition-transform duration-200 hover:-translate-y-1"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
};
